确认收货卡片消息
<template>
  <div class="Card">
    <div class="header">请确认收货地址</div>
    <div class="body">
      <!-- 头部 -->
      <div class="body_top">
        <div class="imgs" v-for="item in drugList" :key="item.drugImageUrl">
          <div class="img-box">
            <img class="img" :src="item.drugImageUrl" />
            <!-- 数量 -->
            <div class="num-tips" v-if="item.buyQuantity">x{{ item.buyQuantity }}</div>
          </div>
          <div class="img-text">{{ item.drugName }}</div>
        </div>
        <view class="imgs_number">共{{ content.totalBuyQuantity }}件</view>
      </div>
      <!-- 下面内容区域 -->
      <div class="content">
        <div class="item">
          <div class="left">收件人：</div>
          <div class="right">{{ content.receiverName }}</div>
        </div>
        <div class="item">
          <div class="left">手机号：</div>
          <div class="right">{{ content.receiverPhone }}</div>
        </div>
        <div class="item">
          <div class="left">地址：</div>
          <div class="right">{{ content.receiverAddress }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { defineProps } from 'vue'
const props = defineProps({
  msg: {
    type: Object,
    default: () => {},
    required: true
  }
})
const content = computed(() => {
  console.log(`output->`, props.msg)
  return props.msg || {}
})
const allDrugList = computed(() => {
  if (!content.value?.drugList) return []
  const drugList = JSON.parse(content.value?.drugList)
  return drugList
})
const drugList = computed(() => {
  let list = []
  // 如果长度超过三截取前三个
  if (allDrugList.value.length > 3) {
    list = allDrugList.value.slice(0, 3)
  } else {
    list = allDrugList.value
  }
  return list
})
</script>

<style scoped lang="scss">
.Card {
  border-radius: 0 8px 8px;
  width: 255px;
  .header {
    position: relative;
    height: 46px;
    line-height: 46px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-left: 12px;
    color: #1a1a1a;
    font-size: 16px;
    font-weight: 500;
    width: 100%;
    border-bottom: 1px solid #efefef;
  }

  .body {
    padding: 0 12px;
    margin: 12px 0;
    border-radius: 8px;
    font-size: 13px;
    .body_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .imgs {
        width: 60px;
        .img-box {
          width: 100%;
          height: 60px;
          border: 1px solid #eeeeee;
          position: relative;
          border-radius: 4px;
          overflow: hidden;
          margin-left: 4px;
          &:first-child {
            margin-left: 0;
          }
          .img {
            width: 100%;
            height: 100%;
          }
          .num-tips {
            color: white;
            position: absolute;
            bottom: 0;
            right: 0;
            border-radius: 4px 0 4px 0;
            padding: 2px 4px;
            background: rgba(0, 0, 0, 0.4);
            font-size: 10px;
          }
        }
        .img-text {
          margin-top: 4px;
          font-size: 12px;
          color: #3b3b3b;
          // 超出部分省略
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
        }
      }
      .imgs_number {
        font-weight: 400;
        font-size: 13px;
        color: #3b3b3b;
      }
    }
    .content {
      padding: 8px 12px;
      background: #f5f7f9;
      color: #3b3b3b;
      margin: 16px 0;
      border-radius: 8px;
      .item {
        margin-bottom: 3px;
        display: flex;
        font-weight: 400;
        font-size: 14px;
        color: #3b3b3b;
        &:last-child {
          margin: 0;
        }
        .left {
          width: 60px;
          flex-shrink: 0;
        }
        .right {
          flex-grow: 1;
        }
      }
    }
  }
  .footer {
    padding: 0 12px 12px;
    text-align: right;
    font-size: 14px;
    .btn-item {
      display: inline-block;
      margin-right: 12px;
      background: #4c6ee0;
      border-radius: 8px;
      padding: 8px 16px;
      color: white;
      text-align: center;
      border: 1px solid #e3e3e3;
      &:last-child {
        margin-right: 0;
      }
    }
    .btn-white {
      background: white;
      color: #3b3b3b;
    }
    .check-button {
      background: #ffffff;
      border: 1px solid #e3e3e3;
      border-radius: 8px;
      color: #bfbfbf;
      padding: 8px 0;
      text-align: center;
    }
  }
}
</style>
